import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastroConsumidor } from './types';

export const INITIAL_STATE: CadastroConsumidor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastroConsumidor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRO_CONSUMIDOR_REQUEST: {
				break;
			}
			case Types.CADASTRO_CONSUMIDOR_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CADASTRO_CONSUMIDOR_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRO_CONSUMIDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
